class NotLoggedInError extends Error {
    constructor() {
        super('You are not logged in.');
    }
}

class ApiError extends Error {}

export {NotLoggedInError, ApiError};